module.exports = __webpack_public_path__ + "img/41.8627d3ea.jpg";